module.exports = __webpack_public_path__ + "img/galeria-aquicultura-5.54f103a3.jpg";